import { ProfileTemplateFieldMode } from '@up2stay/up2promo-api-client';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@up2stay/up2promo-ui';

import { SettingsInfoHint } from '@/core/components/settings/settings-info-hint';
import {
  normalizePolicyMode,
  TEMPLATE_POLICY_OPTIONS,
} from '@/core/lib/profile-template-fields';
import { useDictionary } from '@/core/providers/dictionary-provider';

interface TemplateFieldPolicySelectProps {
  value: ProfileTemplateFieldMode | undefined;
  onChange: (mode: ProfileTemplateFieldMode) => void;
  disabled?: boolean;
  labels: {
    locked: string;
    free: string;
  };
  className?: string;
}

export function TemplateFieldPolicySelect({
  value,
  onChange,
  disabled = false,
  labels,
  className,
}: TemplateFieldPolicySelectProps) {
  const normalized = normalizePolicyMode(value);
  const policyHint = useDictionary().workspace.profileTemplates;

  return (
    <div className="flex min-w-0 items-center gap-0.5">
      <Select
        value={normalized}
        disabled={disabled}
        onValueChange={(v) => onChange(v as ProfileTemplateFieldMode)}
      >
        <SelectTrigger className={className ?? 'w-full sm:w-[11rem] shrink-0'}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {TEMPLATE_POLICY_OPTIONS.map((mode) => (
            <SelectItem key={mode} value={mode}>
              {mode === ProfileTemplateFieldMode.LOCKED
                ? labels.locked
                : labels.free}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <SettingsInfoHint
        label={policyHint.policyHintLabel}
        side="top"
        align="end"
        contentClassName="max-w-[18rem]"
      >
        {policyHint.policyHint}
      </SettingsInfoHint>
    </div>
  );
}
